import { useLocation } from "react-router-dom";

const copy: Record<string, { title: string; body: string }> = {
  "/partners": {
    title: "Partners",
    body: "Reseller orgs, branding, and child tenants will be managed here (Implementation Plan Phase 2–3).",
  },
};

export function PlaceholderPage() {
  const { pathname } = useLocation();
  const c = copy[pathname] ?? { title: "Coming soon", body: "This section is not built yet." };

  return (
    <div>
      <p className="sd-kicker">Roadmap</p>
      <h1 className="sd-h1">{c.title}</h1>
      <p className="sd-lead">{c.body}</p>
      <div className="sd-main-card" style={{ color: "var(--sd-muted)", fontSize: "0.9rem" }}>
        UI scaffolding is in place so we can iterate on layout and components while backend features land.
      </div>
    </div>
  );
}
